/**
 * Login.tsx
 * ------------------------------------------------------------
 * 1.  Se usa `useNavigate` en lugar de `window.location.href`.
 * 2.  Se deshabilita el botón mientras falten datos o haya carga.
 * 3.  Se tipa correctamente `userData`.
 * 4.  Se centraliza el mapeo id→campo con `name` para evitar lógica
 *     ternaria al escribir en los inputs.
 * ------------------------------------------------------------
 */

import { ReactElement, useState, ChangeEvent, MouseEvent } from "react";
import {
  Button,
  Card,
  FormControl,
  Grid2 as Grid,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import { VisibilityOff, Visibility, Home } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import { Item } from "../shared/Item";
import LoadingSpinner from "../shared/LoadingSpinner";
import { handleUserLogin } from "services/UserService";
import { saveCookie } from "utils/cookies.util";

// ---------- Tipado ----------
interface Credentials {
  username: string;
  pass: string;
}

const Login = (): ReactElement => {
  const [userData, setUserData] = useState<Credentials>({
    username: "",
    pass: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // ---------- handlers ----------
  const onChange = (e: ChangeEvent<HTMLInputElement>) =>
    setUserData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const toggleShowPassword = () => setShowPassword((v) => !v);

  const preventDefault = (e: MouseEvent<HTMLButtonElement>) =>
    e.preventDefault();

  const onLogin = async () => {
    setIsLoading(true);
    const response = await handleUserLogin(userData.username, userData.pass);
    //debugger
    setIsLoading(false);

    if (response) {
      saveCookie('usrCookie', response)
      setTimeout(() => navigate("/dashboard"), 500);
    }
    else alert("Usuario o contraseña incorrectos");
  };

  const fieldsIncomplete = !userData.username || !userData.pass;

  // ---------- render ----------
  return isLoading ? (
    <LoadingSpinner />
  ) : (
    <div style={{ maxWidth: 650, minWidth: 380, marginInline: "auto" }}>
      <Card>
        <Grid container spacing={1}>
          <Grid size={12}>
            <Typography variant="h4">Welcome to Admin Dashboard</Typography>
          </Grid>

          {/* Username */}
          <Grid size={1} />
          <Grid size={3}>
            <Item>User Name</Item>
          </Grid>
          <Grid size={1} />
          <Grid size={6}>
            <TextField
              variant="standard"
              id="userText"
              name="username"
              fullWidth
              value={userData.username}
              onChange={onChange}
            />
          </Grid>

          {/* Password */}
          <Grid size={1} />
          <Grid size={1} />
          <Grid size={3}>
            <Item>Password</Item>
          </Grid>
          <Grid size={1} />
          <Grid size={6}>
            <FormControl
              sx={{ m: 1, width: "25ch" }}
              variant="standard"
              fullWidth
            >
              <InputLabel htmlFor="passwordText">Password</InputLabel>
              <Input
                id="passwordText"
                name="pass"
                type={showPassword ? "text" : "password"}
                value={userData.pass}
                onChange={onChange}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={
                        showPassword
                          ? "hide the password"
                          : "display the password"
                      }
                      onClick={toggleShowPassword}
                      onMouseDown={preventDefault}
                      onMouseUp={preventDefault}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>

          {/* Botones */}
          <Grid size={1} />
          <Grid size={7} />
          <Grid size={3}>
            <Button variant="outlined" onClick={() => navigate("/")}>
              <Home /> go home
            </Button>
          </Grid>
          <Grid size={2}>
            <Button
              variant="contained"
              onClick={onLogin}
              disabled={fieldsIncomplete || isLoading}
            >
              Login
            </Button>
          </Grid>
        </Grid>
        <p />
      </Card>
    </div>
  );
};

export default Login;


// import { ReactElement, useState } from "react";
// import { Button, Card, FormControl, Grid2 as Grid, IconButton, Input, InputAdornment, InputLabel, TextField, Typography } from "@mui/material";
// import { VisibilityOff, Visibility, Home } from '@mui/icons-material';
// import { Item } from "../shared/Item";
// import LoadingSpinner from "../shared/LoadingSpinner";
// import { handleUserLogin } from "services/UserService";

// const Login = (): ReactElement => {
//     const [userData, setUserData] = useState({name:'sapo', pass:'mipassword'});
//     const [isLoading, setIsLoading] = useState<boolean>(false);
//     const [showPassword, setShowPassword] = useState<boolean>(false);

//     /**
//      *
//      * @returns Mouse actions
//      */
//     const handleClickShowPassword = () => setShowPassword(!showPassword)
//     const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
//         event.preventDefault();
//     };
//     const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
//         event.preventDefault();
//     };

//     /**
//      * Text inputs
//      */
//     const handleChange = () => { };

//     const handleLogin = () => {
//         setTimeout(() => { setIsLoading(true); }, 500);
//         handleUserLogin(userData.name, userData.pass);

//         //window.location.href = "/Dashboard"
//     }

//     return <>{isLoading ? <LoadingSpinner /> :
//         <div style={{ maxWidth: '650px', minWidth: '380px', marginInline: 'auto' }}>
//             <Card>
//                 <Grid container spacing={1}>
//                     <Grid size={12}>
//                         <Typography variant="h4">Welcome to Admin Dashboard</Typography>
//                     </Grid>
//                     <Grid size={1} />
//                     <Grid size={3}>
//                         <Item>User Name</Item>
//                     </Grid>
//                     <Grid size={1} />
//                     <Grid size={6}>
//                         <TextField variant="standard" id="userText" fullWidth={true} onChange={() => handleChange()} />
//                     </Grid>
//                     <Grid size={1} />
//                     <Grid size={1} />
//                     <Grid size={3}>
//                         <Item>Password</Item>
//                     </Grid>
//                     <Grid size={1} />
//                     <Grid size={6}>
//                         <FormControl sx={{ m: 1, width: '25ch' }} variant="standard" fullWidth={true}>
//                             <InputLabel htmlFor="standard-adornment-password">Password</InputLabel>
//                             <Input
//                                 fullWidth={true}
//                                 id="standard-adornment-password"
//                                 type={showPassword ? 'text' : 'password'}
//                                 endAdornment={
//                                     <InputAdornment position="end">
//                                         <IconButton
//                                             aria-label={
//                                                 showPassword ? 'hide the password' : 'display the password'
//                                             }
//                                             onClick={handleClickShowPassword}
//                                             onMouseDown={handleMouseDownPassword}
//                                             onMouseUp={handleMouseUpPassword}
//                                         >
//                                             {showPassword ? <VisibilityOff /> : <Visibility />}
//                                         </IconButton>
//                                     </InputAdornment>
//                                 }
//                             />
//                         </FormControl>
//                     </Grid>
//                     <Grid size={1} />
//                     <Grid size={7} />
//                     <Grid size={3}>
//                         <Button variant="outlined" onClick={() => window.location.href = "/"}><Home /> go home</Button>
//                     </Grid>
//                     <Grid size={2}>
//                         <Button variant="contained" onClick={() => handleLogin()}>Login</Button>
//                     </Grid>
//                 </Grid>
//                 <p />
//             </Card>
//         </div>}
//     </>
// }

// export default Login;

